import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CompanyForm } from '@/components/forms/company-form'
import { ApplicationShell } from '@/components/forms/application-shell'

const STEPS = [
    'We reply within two working days to set up a short call about the role, the team and the craft you value.',
    'Together we write the brief, and we share it privately with the scouts who know this kind of designer.',
    'Your first shortlist arrives in Slack or your hiring tools, usually within nine working days.'
]

const GetStarted: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Get started'
                description='Tell us who you need. Kerning introduces you to designers hand-picked by scouts the design community trusts, and you pay nothing until you hire.'
            />

            <ApplicationShell
                title='Tell us who you need'
                intro='Share a few details about the role. We will take it from there, and you pay nothing until you hire.'
                steps={STEPS}
            >
                <CompanyForm />
            </ApplicationShell>
        </Layout>
    )
}

export default GetStarted
